import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const fetchAgents = createAsyncThunk(
  "agents/fetchAgents",
  async (token, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/agents`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage = responseDataError.error || "Произошла ошибка";
        return rejectWithValue(errorMessage);
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const updateAgent = createAsyncThunk(
  "agents/updateAgent",
  async ({ id, data }, { rejectWithValue }) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    try {
      const response = await apiClient.patch(`/api/v1/agents/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Профиль успешно обновлен!");
      return response.data;
    } catch (error) {
      if (error.response) {
        const errorMessage =
          error.response.data?.error || "Ошибка при обновлении агента";
        return rejectWithValue(errorMessage);
      } else if (error.request) {
        return rejectWithValue("Нет ответа от сервера");
      } else {
        return rejectWithValue(error.message);
      }
      toast.error(error.error || "Ошибка при обновлении профиля!");
    }
  },
);

const agentsSlice = createSlice({
  name: "agents",
  initialState: {
    agents: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgents.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = action.payload;
      })
      .addCase(fetchAgents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateAgent.fulfilled, (state, action) => {
        const index = state.agents.findIndex(
          (agent) => agent.id === action.payload.id,
        );
        if (index !== -1) state.agents[index] = action.payload;
      })
      .addCase(updateAgent.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default agentsSlice.reducer;
